<template>
  <div class="feature-icon-list">
    <div class="row">
      <div class="col-lg-6">
        <div class="feature-icon-list__media wow move-up">
          <img src="../../assets/img/features/aeroland-feature-icon-image.png" class="img-fluid"
               alt="">
        </div>
      </div>
      <div class="col-lg-6">
        <div class="feature-icon-list__content">
          <div class="feature-icon-list-wrapper">
            <div v-for="feature in features" :key="feature.id"
                 class="single-feature-icon wow move-up">
              <div class="single-feature-icon__media">
                <img :src="feature.icon" class="img-fluid" alt="">
              </div>
              <div class="single-feature-icon__content">
                <h6 class="title" style="font-size: 18px" >{{ feature.title }}</h6>
                <div class="text">{{ feature.desc }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
    export default {
        name: 'featureList',
        data() {
            return {
                features: [
                    {
                        icon: require('../../assets/img/icons/aeroland-branding-box-image-01-1.png'),
                        title: 'Your business needs scale',
                        desc: 'As a growth hacker you are driven by a laser-focused\n' +
                            'passion: you want to scale your business and you want\n' +
                            'to do it faster.'
                    },
                    {
                        icon: require('../../assets/img/icons/aeroland-branding-box-image-02-1.png'),
                        title: 'Manual processes slow you down',
                        desc: 'But most of your time is wasted figuring out how to get new\n' +
                            'contacts and reaching out to them manually. It\'s a tedious process\n' +
                            'that drains your energy and creativity and is slowing you down.\n'

                    },
                    {
                        icon: require('../../assets/img/icons/aeroland-branding-box-image-03-1.png'),
                        title: 'How many opportunities are you missing?',
                        desc: 'You\'re missing lots of invaluable opportunities for growth by not\n' +
                            'automating your lead generation funnel. You need to spend less\n' +
                            'time finding your leads and more time talking with them.'
                    },
                ]
            }
        }
    }
</script>
